import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  AccountTree,
  Assessment,
  BugReport,
  Dashboard,
  HomeWork,
  Schedule,
  ViewList,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageWithHeader from "../common/PageWithHeader";
import { ProTrackDashboard } from "./protrack/ProTrackDashboard";
import { ProTrackProjects } from "./protrack/ProTrackProjects";
import { ProTrackProgramme } from "./protrack/ProTrackProgramme";
import { ProTrackSnagList } from "./protrack/ProTrackSnagList";
import { ProTrackHandovers } from "./protrack/ProTrackHandovers";
import { ProTrackReports } from "./protrack/ProTrackReports";

const COMS_NAVY = "#123456";

const TABS = [
  { label: "Dashboard", icon: <Dashboard sx={{ fontSize: 18 }} /> },
  { label: "CTC Projects", icon: <ViewList sx={{ fontSize: 18 }} /> },
  { label: "Programme", icon: <Schedule sx={{ fontSize: 18 }} /> },
  { label: "Snag List", icon: <BugReport sx={{ fontSize: 18 }} /> },
  { label: "Handovers", icon: <HomeWork sx={{ fontSize: 18 }} /> },
  { label: "Reports", icon: <Assessment sx={{ fontSize: 18 }} /> },
];

const ProTrackHome: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  return (
    <PageWithHeader>
      {/* Header */}
      <Box sx={{ bgcolor: COMS_NAVY, color: "#fff", px: 5, py: 3 }}>
        <Typography
          variant="body2"
          sx={{ color: "rgba(255,255,255,0.6)", cursor: "pointer", mb: 0.5 }}
          onClick={() => navigate("/coms")}
        >
          ← COMS
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mt={1}>
          <AccountTree sx={{ fontSize: 36 }} />
          <Box>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 700 }}>
              ProTrack
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
              CTC project lifecycle tracking — 6-stage portfolio across all
              sites.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Navigation tabs */}
      <Box sx={{ borderBottom: "1px solid #e0e0e0", bgcolor: "#fff", px: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: 14,
              minHeight: 48,
            },
          }}
        >
          {TABS.map((t, i) => (
            <Tab key={i} label={t.label} icon={t.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box px={5} py={4}>
        {tab === 0 && <ProTrackDashboard />}
        {tab === 1 && <ProTrackProjects />}
        {tab === 2 && <ProTrackProgramme />}
        {tab === 3 && <ProTrackSnagList />}
        {tab === 4 && <ProTrackHandovers />}
        {tab === 5 && <ProTrackReports />}
      </Box>
    </PageWithHeader>
  );
};

export default ProTrackHome;
